import { ref } from 'vue'
let sequence = 0
export const settingsNavigationNotice = ref<{ id: number; message?: string } | null>(null)
export function showSettingsNavigationNotice(message?: string) {
  settingsNavigationNotice.value = { id: ++sequence, message }
}
export function clearSettingsNavigationNotice() {
  settingsNavigationNotice.value = null
}
